// Configuração centralizada de módulos e navegação

export const modules = [
  {
    id: "analytics",
    name: "Análise e Performance",
    icon: "mdi-chart-line",
    color: "#3A7D44",
    description: "Relatórios, dashboards, indicadores e consultas genéricas",
    groups: ["Performance", "Consulta Genérica", "Stratws", "Invita"],
    //disabled: true, // Temporariamente desativado
  },
  {
    id: "contactCenter",
    name: "Contact Center",
    icon: "mdi-headset",
    color: "#355C7D",
    description: "SAC, atendimento, chat, mensageria e comunicação",
    groups: [
      "SAC",
      "Mensageria",
      "Central de Consultas",
      "Benefícios",
      "Relacionamento",
    ],
  },
  {
    id: "communication",
    name: "Comunicação",
    icon: "mdi-message-text-outline",
    color: "#0288D1",
    description: "Mensageria, SAC, Chat",
    groups: ["SAC", "Mensageria"],
    searchKeywords: ["Email", "E-mail", "caixa de entrada"],
    externalRoute: "/modulo-comunicacao",
    roles: ["ROLE_ADMIN", "ROLE_COMUNICACAO"],

    isNew: true,
  },
  {
    id: "financial",
    name: "Financeiro",
    icon: "mdi-cash-multiple",
    color: "#C77700",
    description: "Fluxo financeiro, radar, conciliação e documentos",
    groups: ["Financeiro"],
    externalRoute: "/modulo-financeiro",
    roles: ["ROLE_ADMIN", "ROLE_FINANCEIRO"],
    isNew: true,
  },
  {
    id: "commercial",
    name: "Comercial",
    icon: "mdi-storefront-outline",
    color: "#6A1B9A",
    description: "Módulo comercial GPDF",
    groups: [],
    externalRoute: "/modulo-comercial",
    roles: ["ROLE_ADMIN", "ROLE_COMERCIAL"],
    isNew: true,
  },
  {
    id: "digitalSignature",
    name: "Assinatura Digital",
    icon: "mdi-draw-pen",
    color: "#00838F",
    description: "Assinatura digital de documentos",
    groups: [],
    externalRoute: "/modulo-assinatura-digital",
    roles: ["ROLE_ADMIN", "ROLE_ASSINATURA"],
    isNew: true,
  },
  {
    id: "operations",
    name: "Operações",
    icon: "mdi-cog-outline",
    color: "#5E3A87",
    description:
      "Comissões, colaboradores, fluxo de serviços e portais externos",
    groups: [
      "Comissão",
      "Gestão",
      "Fluxos",
      "Relatórios",
      "Plataformas",
      "GED",
    ],
    searchKeywords: ["Ged", "Drive", "Pastas", "Bate papo", "Bate-papo"],
  },
  {
    id: "management",
    name: "Gestão",
    icon: "mdi-briefcase-outline",
    color: "#A63D40",
    description: "Acompanhamento, auditoria, gestão de carteira e chamados",
    groups: ["Acompanhamento", "Chamados"],
  },
  {
    id: "partnerPortal",
    name: "Portal da Transparência",
    icon: "mdi-account-group",
    color: "#2E7D32",
    description: "Portal da transparência",
    groups: ["Portal Sócios"],
    roles: ["ROLE_ADMIN"],
  },
  {
    id: "employeePortal",
    name: "Portal do Colaborador",
    icon: "mdi-account-tie",
    color: "#1565C0",
    description: "Portal interno para colaboradores",
    groups: [],
    searchKeywords: ["Feed", "Notícias", "Abrir Chamado", "Base de Conhecimento", "Universidade", "Mural", "Meus Dados"],
    externalRoute: "/modulo-colaborador",
    openAccess: true,
    isNew: true,
  },
  {
    id: "admin",
    name: "Administração",
    icon: "mdi-shield-account",
    color: "#455A64",
    description: "Configurações, usuários, permissões e sistema",
    groups: ["Administrador", "Campanha"],
  },
];

// Itens de navegação do Drawer (mesma estrutura do Drawer.vue)
export const drawerItems = [
  {
    title: "Performance",
    roles: [
      "ROLE_RESUMO",
      "ROLE_CAMPANHA",
      "ROLE_CONTRATO",
      "ROLE_OBITO",
      "ROLE_SEPULTAMENTO",
      "ROLE_INADIMPLENCIA_PERFORMANCE",
      "ROLE_ACORDO_PERFORMANCE",
      "ROLE_SINISTRALIDADE",
      "ROLE_CONTAS",
    ],
  },

  {
    icon: "mdi-calculator",
    title: "Resumo",
    roles: ["ROLE_RESUMO"],
    to: "financeiro",
  },

  {
    icon: "mdi-file-document-check-outline",
    title: "Carteira",
    roles: ["ROLE_CONTRATO"],
    to: "contrato",
  },

  {
    icon: "mdi-coffin",
    title: "Óbitos",
    roles: ["ROLE_OBITO"],
    to: "obito",
  },

  {
    icon: "mdi-flower",
    title: "Sepultamento",
    roles: ["ROLE_SEPULTAMENTO"],
    to: "sepultamento",
  },

  {
    icon: "mdi-cash-clock",
    title: "Inadimplência",
    roles: ["ROLE_INADIMPLENCIA_PERFORMANCE"],
    to: "inadimplenciaPerformance",
  },

  {
    icon: "mdi-handshake",
    title: "Acordos",
    roles: ["ROLE_ACORDO_PERFORMANCE"],
    to: "acordosPerformance",
  },

  {
    icon: "mdi-alert",
    title: "Sinistralidade",
    roles: ["ROLE_SINISTRALIDADE"],
    to: "sinistralidade",
  },

  {
    icon: "mdi-calculator",
    title: "Contas",
    roles: ["ROLE_CONTAS"],
    to: "contas",
  },

  {
    title: "",
  },

  {
    title: "GED",
    roles: [
      "ROLE_IMPORTACAO_CONSULTA",
      "ROLE_IMPORTACAO_DOWNLOAD",
      "ROLE_IMPORTACAO_FILE_STATUS",
      "ROLE_IMPORTACAO_FILE",
    ],
  },

  {
    icon: "mdi-file-arrow-up-down-outline",
    title: "Arquivos",
    roles: [
      "ROLE_IMPORTACAO_CONSULTA",
      "ROLE_IMPORTACAO_DOWNLOAD",
      "ROLE_IMPORTACAO_FILE_STATUS",
      "ROLE_IMPORTACAO_FILE",
    ],
    to: "gestaoArquivos",
  },

  {
    title: "",
  },

  {
    title: "Acompanhamento",
    roles: [
      "ROLE_AUDITORIA",
      "ROLE_COBRANCA",
      "ROLE_FATURAMENTO",
      "ROLE_ACOMPANHAMENTO_VENDA",
      "ROLE_REMESSA_NEGATIVADO",
      "ROLE_NEGATIVADO",
      "ROLE_FUNERARIA",
      "ROLE_LOJA",
      "ROLE_RETENCAO",
      "ROLE_RETENCAO_VENDEDOR",
      "ROLE_IMPORTACAO_CONSULTA",
      "ROLE_IMPORTACAO_DOWNLOAD",
      "ROLE_IMPORTACAO_FILE_STATUS",
      "ROLE_IMPORTACAO_FILE",
      "ROLE_GESTAO_CARTEIRA",
      "ROLE_FALECIDOS",
    ],
  },

  {
    icon: "mdi-marker",
    title: "Auditoria",
    roles: ["ROLE_AUDITORIA"],
    to: "auditoria",
  },

  {
    icon: "mdi-cash-refund",
    title: "Cobrança",
    roles: ["ROLE_REMESSA_NEGATIVADO", "ROLE_COBRANCA", "ROLE_NEGATIVADO"],
    to: "cobranca",
    group: "",
    children: [
      {
        icon: "mdi-cash-refund",
        title: "Acordos",
        // roles: [ 'ROLE_COBRANCA'],
        to: "cobranca",
      },

      {
        title: "Negativados",
        //  roles: [ 'ROLE_NEGATIVADO'],
        to: "negativados",
      },

      {
        title: "Remessa Serasa",
        // roles: [ 'ROLE_REMESSA_NEGATIVADO'],
        to: "remessa",
      },
    ],
  },

  {
    icon: "mdi-finance",
    title: "Faturamento",
    roles: ["ROLE_FATURAMENTO"],
    to: "faturamento",
  },

  {
    icon: "mdi-sale",
    title: "Vendas",
    roles: ["ROLE_ACOMPANHAMENTO_VENDA"],
    to: "acompanhamentovenda",
  },

  {
    icon: "mdi-toolbox-outline",
    title: "Funerária",
    roles: ["ROLE_FUNERARIA"],
    to: "funeraria",
  },

  {
    icon: "mdi-store",
    title: "Loja",
    roles: ["ROLE_LOJA"],
    to: "loja",
  },

  {
    icon: "mdi-safe",
    title: "Retenção de Vendas",
    roles: ["ROLE_RETENCAO", "ROLE_RETENCAO_VENDEDOR"],
    to: "retencao",
  },

  {
    icon: "mdi-wallet-outline",
    title: "Gestão de Carteira",
    roles: ["ROLE_GESTAO_CARTEIRA"],
    to: "gestaoCarteira",
  },

  {
    icon: "mdi-grave-stone",
    title: "Falecidos",
    roles: ["ROLE_FALECIDOS"],
    to: "falecidos",
  },

  {
    title: "",
  },

  {
    title: "SAC",
  },

  /*
  {
    icon: "mdi-chat",
    title: "Chat",
    roles: ["ROLE_CHAT"],
    to: "chat",
  },
  */
  {
    icon: "mdi-message-fast-outline",
    title: "Chat",
    roles: ["ROLE_CHAT_V2", "ROLE_CHAT"],
    to: "v2chat",
  },
  {
    icon: "mdi-message-reply-text-outline",
    title: "Chat Receptivo",
    roles: ["ROLE_ADMIN"],
    to: "chat-wazzup",
  },
  {
    icon: "mdi-magnify",
    title: "Chat Supervisor",
    roles: ["ROLE_CHAT_CONSULTA"],
    to: "consulta-chat",
  },
  {
    icon: "mdi-view-dashboard-outline",
    title: "Painel",
    roles: ["ROLE_CHAT_PAINEL"],
    to: "painel-chat",
  },
  {
    icon: "mdi-format-list-bulleted",
    title: "Filas",
    roles: ["ROLE_CHAT_FILAS"],
    to: "filas",
  },
  {
    icon: "mdi-message-text-outline",
    title: "Templates",
    roles: ["ROLE_TEMPLATES"],
    to: "templates",
  },
  {
    icon: "mdi-tune",
    title: "Parâmetros",
    roles: [
      "ROLE_ADMIN",
      "ROLE_PARAMETROS",
      "ROLE_TEMPLATES",
      "ROLE_PARAMETROS_CADASTRO",
      "ROLE_PARAMETROS_CONSULTA",
    ],
    to: "parametros",
  },
  {
    icon: "mdi-robot",
    title: "URAs",
    roles: ["ROLE_URAS"],
    to: "uras",
  },
  {
    icon: "mdi-tag-multiple",
    title: "Etiquetas",
    roles: ["ROLE_ADMIN", "ROLE_ETIQUETA_CONSULTA", "ROLE_ETIQUETA_CADASTRO"],
    to: "etiquetas",
  },

  {
    title: "",
  },

  {
    title: "Central de Consultas",
    roles: ["ROLE_ADMIN", "ROLE_LTV"],
  },

  {
    icon: "mdi-magnify-scan",
    title: "Análise",
    roles: ["ROLE_ADMIN"],
    to: "central-consultas-analise",
  },

  {
    icon: "mdi-cash-check",
    title: "Saldo",
    roles: ["ROLE_ADMIN"],
    to: "central-consultas-saldo",
  },

  {
    icon: "mdi-chart-box-outline",
    title: "LTV",
    roles: ["ROLE_ADMIN", "ROLE_LTV"],
    to: "consulta-ltv",
  },

  {
    title: "",
  },

  {
    title: "Benefícios",
    roles: [
      "ROLE_ADMIN",
      "ROLE_ADMINISTRADOR_TEMSAUDE_CARTAO",
      "ROLE_ADMINISTRADOR_TEMSAUDE_LISTAGEM",
    ],
  },

  {
    icon: "mdi-heart-pulse",
    title: "TEM Saúde",
    roles: ["ROLE_ADMIN", "ROLE_ADMINISTRADOR_TEMSAUDE_CARTAO"],
    to: "tem-saude",
  },

  {
    icon: "mdi-card-multiple",
    title: "TEM Saúde Lote",
    roles: ["ROLE_ADMIN", "ROLE_ADMINISTRADOR_TEMSAUDE_LISTAGEM"],
    to: "tem-saude-lote",
  },

  {
    title: "",
  },
  {
    title: "Relacionamento",
    roles: ["ROLE_ADMIN", "ROLE_CARNE_DIGITAL"],
  },

  {
    icon: "mdi-file-document-outline",
    title: "Carnê digital",
    roles: ["ROLE_ADMIN", "ROLE_CARNE_DIGITAL"],
    to: "carne-digital",
  },

  {
    title: "",
  },

  {
    title: "Comunicação Interna",
    roles: ["ROLE_BATEPAPO"],
  },
  {
    icon: "mdi-comment-account-outline",
    title: "Batepapo",
    roles: ["ROLE_BATEPAPO"],
    to: "batepapo",
  },

  {
    title: "",
  },

  {
    title: "Fluxos",
    roles: [
      "ROLE_SERVICO_FUNERARIO",
      "ROLE_SERVICO_FUNERARIO_EDICAO",
      "ROLE_FLUXO_DEVOLVIDO",
      "ROLE_FLUXO_CEMITERIAL",
      "ROLE_FLUXO_COBRANCA",
      "ROLE_FLUXO_COBRANCA_CONSULTA_SUPERVISOR",
      "ROLE_FLUXO_COBRANCA_CONSULTA_OPERADOR",
      "ROLE_FLUXO_VENDAS",
      "ROLE_FLUXO_VENDAS_SUPERVISOR",
      "ROLE_COLOCACAO_VASO",
      "ROLE_ADMIN",
      "ROLE_ALOCACOES"
    ],
  },

  {
    icon: "mdi-coffin",
    title: "Funerário",
    roles: ["ROLE_SERVICO_FUNERARIO", "ROLE_SERVICO_FUNERARIO_EDICAO"],
    to: "fluxo-servico-funerario",
  },

  {
    icon: "mdi-account-switch",
    title: "Alocações",
    roles: ["ROLE_ADMIN", "ROLE_ALOCACOES"],
    to: "fluxo-alocacoes",
  },

  {
    icon: "mdi-grave-stone",
    title: "Cemiterial",
    roles: ["ROLE_FLUXO_CEMITERIAL"],
    to: "fluxo-cemiterial",
  },
  {
    icon: "mdi-flower",
    title: "Mensalista Floral",
    roles: ["ROLE_COLOCACAO_VASO"],
    to: "fluxo-colocacao-vaso",
  },
  {
    icon: "mdi-file-rotate-left",
    title: "Entrega",
    roles: ["ROLE_FLUXO_DEVOLVIDO"],
    to: "fluxo-carne-devolvidos",
  },
  {
    icon: "mdi-cash-sync",
    title: "Cobrança",
    roles: [
      "ROLE_FLUXO_COBRANCA",
      "ROLE_FLUXO_COBRANCA_CONSULTA_SUPERVISOR",
      "ROLE_FLUXO_COBRANCA_CONSULTA_OPERADOR",
    ],
    to: "fluxo-cobranca",
    isBeta: true,
  },
  {
    icon: "mdi-cart-check",
    title: "Vendas",
    roles: ["ROLE_FLUXO_VENDAS", "ROLE_FLUXO_VENDAS_SUPERVISOR"],
    to: "fluxo-vendas",
    isBeta: true,
  },
  {
    icon: "mdi-file-document-outline",
    title: "Documentação de Serviços",
    roles: ["ROLE_ADMIN"],
    to: "documentacao-servico-funerario",
  },


  {
    title: "",
  },

  {
    title: "Plataformas",
    roles: ["ROLE_RECORDACOES", "ROLE_JAZIGO", "ROLE_NPS", "ROLE_ECOMMERCE"],
  },

  {
    icon: "mdi-candelabra-fire",
    title: "Velórios",
    roles: ["ROLE_VELORIOS"],
    to: "velorios-andamento",
    external: true,
    url: "https://velorios.gpdf.com.br/",
  },

  {
    icon: "mdi-flower-tulip",
    title: "Recordações",
    roles: ["ROLE_RECORDACOES"],
    to: "recordacoes",
    external: true,
    url: "https://parquedasrecordacoes.com.br/admin/entrar?loginToken=732gjdghj98387U_4723842XUId12IB",
  },

  {
    icon: "mdi-star-outline",
    title: "NPS",
    roles: ["ROLE_NPS"],
    to: "nps",
    external: true,
    url: "https://nps.grupoparque.com.br/entrar?loginToken=732gjdghj98387U_4723842XUId12IB",
  },

  {
    icon: "mdi-cash-sync",
    title: "Loja Virtual",
    roles: ["ROLE_ECOMMERCE"],
    to: "ecommerce",
    external: true,
    url: "https://loja.memorialparquemaceio.com.br",
    isBeta: true,
  },

  {
    title: "",
  },

  {
    title: "Comissão",
    roles: [
      "ROLE_COMISSAO",
      "ROLE_COMISSAO_VENDA",
      "ROLE_COMISSAO_FUNERARIA",
      "ROLE_COMISSAO_ENTREGAS",
      "ROLE_COMISSAO_CONTROLE",
      "ROLE_VENDAS_RADAR",
    ],
  },

  {
    icon: "mdi-percent",
    title: "Acordos",
    roles: ["ROLE_COMISSAO"],
    to: "comissao",
  },

  {
    icon: "mdi-percent",
    title: "Vendas",
    roles: ["ROLE_COMISSAO_VENDA"],
    to: "comissaoVenda",
  },

  /* {
    icon: "mdi-flask-outline",
    title: "Simulação de Vendas",
    roles: ["ROLE_ADMIN"],
    to: "simulacaoVenda",
  }, */

  {
    icon: "mdi-percent",
    title: "Funerária",
    roles: ["ROLE_COMISSAO_FUNERARIA"],
    to: "comissaoFuneraria",
  },

  {
    icon: "mdi-percent",
    title: "Entregas",
    roles: ["ROLE_COMISSAO_ENTREGAS"],
    to: "comissaoEntrega",
  },

  {
    title: "",
  },

  {
    title: "Gestão",
    roles: [
      "ROLE_COMISSAO_CONTROLE",
      "ROLE_COMISSAO_CONTROLE",
      "ROLE_VENDAS_RADAR",
      "ROLE_SEGUROS",
    ],
  },

  {
    icon: "mdi-link-variant",
    title: "Vínculo",
    roles: ["ROLE_COMISSAO_CONTROLE"],
    to: "comissaoControle",
  },

  {
    icon: "mdi-alert-octagon",
    title: "Ocorrência",
    roles: ["ROLE_COMISSAO_CONTROLE"],
    to: "comissaoConformidade",
  },

  {
    icon: "mdi-cash-check",
    title: "Comissões Pagas",
    roles: ["ROLE_COMISSAO_RECEBIMENTO"],
    to: "comissoesRecebidas",
  },

  {
    icon: "mdi-sale",
    title: "Vendas Radar",
    roles: ["ROLE_VENDAS_RADAR"],
    to: "vendasRadar",
  },

  {
    icon: "mdi-gift",
    title: "Comissões Alelo",
    roles: ["ROLE_COMISSAO_ALELO"],
    to: "comissaoAlelo",
  },
  {
    icon: "mdi-account-multiple",
    title: "Grupos Colaboradores",
    roles: ["ROLE_GRUPOS_COLABORADORES"],
    to: "gruposColaboradores",
  },

  {
    icon: "mdi-shield-check-outline",
    title: "Regulação de Seguros",
    roles: ["ROLE_SEGUROS", "ROLE_SEGUROS_CONFIG"],
    to: "relatoriosSeguro",
    group: "",
    children: [
      {
        title: "Gerar Remessa",
        roles: ["ROLE_SEGUROS"],
        to: "relatoriosSeguro",
      },
      {
        title: "Configurar Planos",
        roles: ["ROLE_SEGUROS_CONFIG"],
        to: "configRelatoriosSeguro",
      },
    ],
  },

  {
    title: "",
  },

  {
    title: "Relatórios",
    roles: [
      "ROLE_SERVICO_FUNERARIO_RELATORIO",
      "ROLE_SERVICO_FUNERARIO_RELATORIO_AGENTE",
      "ROLE_ADMIN",
    ],
  },

  {
    icon: "mdi-clipboard-pulse-outline",
    title: "Funerário",
    roles: [
      "ROLE_SERVICO_FUNERARIO_RELATORIO",
      "ROLE_SERVICO_FUNERARIO_RELATORIO_AGENTE",
      "ROLE_ADMIN",
    ],
    to: "relatorio-funerario",
  },

  {
    title: "",
  },

  {
    title: "Bitrix",
    roles: ["ROLE_BITRIX"],
  },

  {
    icon: "mdi-account-multiple",
    title: "Leads",
    roles: ["ROLE_BITRIX"],
    to: "bitrixLead",
  },

  {
    title: "",
  },

  {
    title: "Consulta Genérica",
    roles: [
      "ROLE_RECEITA",
      "ROLE_INADIMPLENCIA",
      "ROLE_VENDA",
      "ROLE_CANCELAMENTO",
      "ROLE_RENEGOCIACAO",
      "ROLE_VENDAS_EMPRESA",
      "ROLE_MANUTENCAO_DOC",
    ],
  },

  {
    icon: "mdi-cash",
    title: "Receita",
    roles: ["ROLE_RECEITA"],
    to: "receita",
  },
  {
    icon: "mdi-filter-variant",
    title: "Consulta Dinamica",
    roles: ["ROLE_ADMIN"],
    to: "consultaDinamica",
  },

  {
    icon: "mdi-robot-happy-outline",
    title: "Assistente de consulta",
    roles: ["ROLE_ADMIN"],
    to: "consultaMassa",
  },

  {
    icon: "mdi-cash-clock",
    title: "Inadimplência",
    roles: ["ROLE_INADIMPLENCIA"],
    to: "inadimplencia",
  },

  {
    icon: "mdi-sale",
    title: "Vendas",
    roles: ["ROLE_VENDA"],
    to: "venda",
  },

  {
    icon: "mdi-sale",
    title: "Entre Empresas",
    roles: ["ROLE_VENDAS_EMPRESA"],
    to: "vendasEmpresas",
  },

  {
    icon: "mdi-delete",
    title: "Cancelamentos",
    roles: ["ROLE_CANCELAMENTO"],
    to: "cancelamento",
  },

  {
    icon: "mdi-handshake",
    title: "Renegociação",
    roles: ["ROLE_RENEGOCIACAO"],
    to: "acordos",
  },

  {
    icon: "mdi-text-box-search-outline",
    title: "Documentos",
    roles: ["ROLE_MANUTENCAO_DOC"],
    to: "documentos",
  },

  {
    title: "",
  },

  {
    title: "Stratws",
    roles: ["ROLE_STRATUS"],
    isBeta: true,
  },
  {
    icon: "mdi-finance",
    title: "Indicadores",
    roles: ["ROLE_STRATUS"],
    to: "indicadores",
  },
  {
    icon: "mdi-cloud-upload",
    title: "Importação Stratws",
    roles: ["ROLE_STRATUS"],
    to: "importacao-stratws",
  },

  {
    title: "",
  },

  {
    title: "Invita",
    roles: ["ROLE_ADMIN"],
  },
  {
    icon: "mdi-file",
    title: "Arquivos DS",
    roles: ["ROLE_ADMIN"],
    to: "invita",
  },

  {
    title: "",
  },
  {
    title: "Chamados",
    roles: ["ROLE_ADMIN", "ROLE_GLPI"],
  },
  {
    icon: "mdi-plus-box-outline",
    title: "Novo Chamado",
    roles: ["ROLE_ADMIN"],
    to: "",
  },
  {
    icon: "mdi-account-clock-outline",
    title: "Meus Chamados",
    roles: ["ROLE_ADMIN"],
    to: "",
  },
  {
    icon: "mdi-clipboard-text-search-outline",
    title: "Consulta GLPI",
    roles: ["ROLE_ADMIN", "ROLE_GLPI"],
    to: "consulta-glpi",
  },
  {
    icon: "mdi-account-group",
    title: "Acompanhamento dos Chamados",
    roles: ["ROLE_ADMIN", "ROLE_GLPI"],
    to: "acompanhamento-glpi",
  },

  {
    title: "",
  },
  {
    title: "Mensageria",
  },
  {
    icon: "mdi-account-arrow-right",
    title: "Envios Clientes",
    roles: ["ROLE_MENSAGERIA_CLIENTES"],
    to: "mensageria-externa",
  },
  {
    icon: "mdi-receipt-text-send",
    title: "Envios Colaboradores",
    roles: ["ROLE_MENSAGERIA_COLABORADORES"],
    to: "mensageria-interna",
  },
  {
    icon: "mdi-email-multiple",
    title: "Envio em Lote",
    roles: ["ROLE_MENSAGERIA_LOTE"],
    to: "mensageria-lote",
  },
  {
    icon: "mdi-cake",
    title: "Aniversário",
    roles: ["ROLE_MENSAGERIA_ANIVERSARIO"],
    to: "mensageria-aniversario",
  },
  {
    icon: "mdi-robot",
    title: "Automações",
    roles: ["ROLE_MENSAGERIA_AUTOMACOES"],
    to: "mensageria-automacao",
  },
  {
    icon: "mdi-magnify",
    title: "Consulta",
    roles: ["ROLE_MENSAGERIA"],
    to: "mensageria-consulta",
  },
  {
    icon: "mdi-block-helper",
    title: "Blacklist",
    roles: ["ROLE_MENSAGERIA", "ROLE_MENSAGERIA_BLACKLIST"],
    to: "blacklist",
  },
  {
    title: "",
  },

  {
    title: "",
  },

  {
    title: "Financeiro",
    roles: [
      "ROLE_IMPORTACAO_RADAR",
      "ROLE_IMPORTACAO_RADAR_APP",
      "ROLE_FLUXO",
      "ROLE_CONCILIACAO",
      "ROLE_DOCUEMNTOS_IVERTEX",
    ],
  },

  {
    icon: "mdi-finance",
    title: "Fluxo",
    roles: ["ROLE_FLUXO"],
    to: "fluxo",
  },

  {
    icon: "mdi-cash-clock",
    title: "Radar Documentos",
    roles: ["ROLE_IMPORTACAO_RADAR"],
    to: "importacao",
  },

  {
    icon: "mdi-cash-clock",
    title: "Importação Radar",
    roles: ["ROLE_IMPORTACAO_RADAR_APP"],
    to: "importacaoapp",
  },

  {
    icon: "mdi-cash-clock",
    title: "Conciliação",
    roles: ["ROLE_CONCILIACAO"],
    to: "conciliacao",
  },

  {
    icon: "mdi-text-box-search-outline",
    title: "Documentos",
    roles: ["ROLE_DOCUEMNTOS_IVERTEX"],
    to: "documentos",
  },
  {
    title: "",
  },

  {
    title: "Portal Sócios",
    roles: ["ROLE_ADMIN"],
  },

  {
    icon: "mdi-web",
    title: "Portal da Transparência",
    roles: ["ROLE_ADMIN"],
    to: "portal-socios",
    external: true,
    url: "https://gpdf.com.br/",
  },

  {
    title: "",
  },

  {
    title: "Campanha",
    roles: ["ROLE_ADMIN"],
  },

  {
    icon: "mdi-cloud-upload",
    title: "Upload de arquivo",
    roles: ["ROLE_ADMIN"],
    to: "campanha-upload",
  },

  {
    title: "",
  },

  {
    title: "Administrador",
    roles: ["ROLE_NOTIFICACAO", "ROLE_LOG", "ROLE_USER", "ROLE_COLABORADORES"],
  },

  {
    icon: "mdi-account-multiple",
    title: "Colaboradores",
    roles: ["ROLE_COLABORADORES"],
    to: "colaboradores",
  },
  {
    icon: "mdi-bell",
    title: "Notificação",
    roles: ["ROLE_NOTIFICACAO"],
    to: "notificacao",
  },

  {
    icon: "mdi-history",
    title: "LOG",
    roles: ["ROLE_LOG"],
    to: "historico",
  },

  {
    icon: "mdi-account",
    title: "Usuário",
    roles: ["ROLE_USER"],
    to: "usuario",
  },

  {
    title: "",
  },

  {
    title: "Configurações",
  },

  {
    icon: "mdi-key",
    title: "Alterar Senha",
    to: "register",
  },

  {
    icon: "mdi-logout",
    title: "Sair",
    to: "login",
  },
];

// Função auxiliar para verificar permissões
export function hasPermission(item, userRoles) {
  if (!item.roles || item.roles.length === 0) return true;
  return item.roles.some((role) => userRoles.includes(role));
}

// Função para contar itens acessíveis em um módulo
export function getModuleItemCount(moduleGroups, userRoles) {
  const isAdmin = userRoles.includes("ROLE_ADMIN");
  let count = 0;
  let currentGroup = null;

  for (const item of drawerItems) {
    // Se é um título de grupo
    if (item.title && !item.to && !item.icon) {
      currentGroup = item.title;
    } else if (currentGroup && moduleGroups.includes(currentGroup)) {
      // Ignora itens vazios (separadores) - sem título ou sem rota
      if (!item.title || !item.to) {
        continue;
      }

      // Se é admin, conta todos os itens. Senão, verifica permissão
      const hasAccess = isAdmin || hasPermission(item, userRoles);

      if (hasAccess) {
        count++;
      } else {
      }
    }
  }

  return count;
}
